import { useAnalytics } from 'ia-react-core';
import { AxiosResponse } from 'axios';
import { useCallback } from 'react';

const useHandleChangePassword = () => {
  const { track } = useAnalytics();
  const useHandleChangePasswordForm = useCallback((response: AxiosResponse<unknown>) => {
    let result = 'Success';
    if (response.status !== 200) {
      result = 'Fail';
    }
    track({
      event: new MouseEvent('click'),
      scope: 'Change Password',
      values:
      {
        change: result,
      },
    });
  }, [track]);

  return useHandleChangePasswordForm;
};

export default useHandleChangePassword;
